export default __webpack_public_path__ + "static/media/agenda-text.54a249d6.png";